module.exports = __webpack_public_path__ + "img/topx.820017e9.png";